import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ApplicationsStore } from 'pages/settings/pages/developer/pages/applications/store/applicationsStore'

type IClientModalActionsProps = {
  store: ApplicationsStore
}

export const ClientModalActions = observer(({ store }: IClientModalActionsProps) => {
  return (
    <Button
      typeBtn='contained'
      text={store.clientModalPrimaryButtonText}
      size='medium'
      disabled={!store.isClientFormValid || store.clientModalSaving}
      loading={store.clientModalSaving}
      onClick={store.handleSaveAuthClient}
    />
  )
})
